import { resetIndexQuery } from '@/services/analytics/Action';
import { useDispatch } from 'react-redux';

export const useResetIndexQuery = () => {
  const dispatch = useDispatch();
  const reset = () => dispatch(resetIndexQuery());
  return [reset];
};
